import { useState, useCallback } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";

export function useClipboard() {
  const { t } = useTranslation();

  const copy = useCallback(async (text: string) => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        toast.success(t("message.link-copy-OK"));
      } else {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      return true;
    } catch (e) {
      console.error("コピーに失敗しました", e);
      toast.error(t("message.link-copy-NG"));
      return false;
    }
  }, []);

  return { copy };
}
